"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _svgFetcher = _interopRequireDefault(require("./svgFetcher"));
var _excluded = ["onLoad"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/*
US4121153: why this func?
(1) it is an alternative func for (a delegate to) the existing svgFetcher.
(2) it does everything svgFetcher does except it also removes id attr
    for all the child elements of the resulting svg element.
(3) the reason we need this extra service is that, some of our old svg source
    contains child elements (e.g. <g>, etc.) having static "id" attribute which
    triggers Accessibility audit warnings about duplicated ids on the same page.
*/
/* eslint no-plusplus: 0 */
/* istanbul ignore next */
var svgFetcherWithIdAttrRemoval = function svgFetcherWithIdAttrRemoval(imageName, directory, props) {
  var _ref = props || {},
    onLoad = _ref.onLoad,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var processEle = function processEle() {
    var ele = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    if (depth > 5) {
      return;
    } // max levels we process is 5
    if (ele.id && ele.removeAttribute) {
      ele.removeAttribute('id');
    }
    if (ele && ele.children && ele.children.length) {
      for (var i = 0; i < ele.children.length; i++) {
        processEle(ele.children[i], depth + 1);
      }
    }
  };
  var onLoadLocal = function onLoadLocal(err) {
    var svg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!err && svg && svg.children && svg.children.length) {
      for (var i = 0; i < svg.children.length; i++) {
        processEle(svg.children[i], 1);
      }
    }
    if (typeof onLoad === 'function') {
      onLoad(err, svg);
    }
  };
  return (0, _svgFetcher["default"])(imageName, directory, _objectSpread(_objectSpread({}, restProps), {}, {
    onLoad: onLoadLocal
  }));
};
var _default = exports["default"] = svgFetcherWithIdAttrRemoval;
module.exports = exports.default;